import { inject } from '@angular/core';
import { ThemeService } from '../services/theme.service';

export const themeInitializer = () => {
  inject(ThemeService).init();
};
